var map = {
	"./EN-AMERICAS.json": 85700,
	"./EN-APAC.json": 88600,
	"./da-DK.json": 83696,
	"./de-AT.json": 28316,
	"./de-CH.json": 62974,
	"./de-DE.json": 31354,
	"./en-DK.json": 91460,
	"./en-EU.json": 77267,
	"./en-GB.json": 24704,
	"./en-SE.json": 93181,
	"./en.json": 51754,
	"./fr-FR.json": 96640,
	"./nb-NO.json": 95655,
	"./sv-SE.json": 12307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14822;